// extracted by mini-css-extract-plugin
module.exports = {"depJobTabs":"DepartmentJob_depJobTabs__2AjH3","tabsPills":"DepartmentJob_tabsPills__1LA_F","tabsItems":"DepartmentJob_tabsItems__2MQKk","tabsLink":"DepartmentJob_tabsLink__ne1hR"};